<script lang="ts">
	import { MessageSenderAvatar } from './index.ts'

	interface Props {
		role: string
	}

	let { role }: Props = $props()
</script>

<div class="flex items-center gap-2">
	<MessageSenderAvatar {role} />
	<div class="text-sm text-se-grey-2">Patrick has joined the chat.</div>
</div>
